import React from "react";
import {
  Autocomplete,
  AutocompleteInputChangeReason,
  AutocompleteChangeReason,
  AutocompleteChangeDetails,
} from "@material-ui/lab";
import { Field, BaseProps } from "./field";
import { Input, InputAdornment, CircularProgress } from "@material-ui/core";

type Props = BaseProps<string> & {
  loading?: boolean;
  options: string[];
  placeholder?: string;
  onInput: (name: any, value: string) => void;
};

const Component: React.FC<Props> = (props) => {
  function onChange(
    event: React.ChangeEvent<{}>,
    value: string | null,
    reason: AutocompleteChangeReason,
    details?: AutocompleteChangeDetails
  ): void {
    if (props.onChange) {
      props.onChange(props.name, value || "");
    }
  }

  function onInput(
    event: React.ChangeEvent<{}>,
    value: string,
    reason: AutocompleteInputChangeReason
  ): void {
    if (reason === "input" && props.onChange) {
      props.onInput(props.name, value);
    }
  }

  return (
    <Field
      label={props.label}
      required={props.required}
      error={props.error}
      disabled={props.disabled}
      size={props.size}
    >
      <Autocomplete
        autoSelect
        blurOnSelect
        noOptionsText={props.loading ? "Loading..." : undefined}
        onChange={onChange}
        onInputChange={onInput}
        options={props.options}
        popupIcon={null}
        renderInput={({ inputProps, InputProps: { ref } }) => (
          <div ref={ref}>
            <Input
              disabled={props.disabled}
              error={!!props.error}
              fullWidth
              inputProps={inputProps}
              name={props.name}
              placeholder={props.placeholder}
              required={props.required}
              endAdornment={
                props.loading ? (
                  <InputAdornment position="end">
                    <CircularProgress size="1rem" />
                  </InputAdornment>
                ) : null
              }
              value={props.value}
            />
          </div>
        )}
        value={props.value}
      />
    </Field>
  );
};

export { Component as Autocomplete };
